import * as zod from 'zod'
import { toTypedSchema } from '@vee-validate/zod'

export const editNextReportDateValidationSchema = toTypedSchema(
    zod.object({
        nextReportDate: zod.string().min(1, 'formInputs.validation.requiredDate'),
    }),
)
